import script from "./Entities.vue?vue&type=script&setup=true&lang=js"
export * from "./Entities.vue?vue&type=script&setup=true&lang=js"

import "./Entities.vue?vue&type=style&index=0&id=674f79ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674f79ba"]])

export default __exports__